import React, { useState, useEffect } from 'react';
import {
  Container,
  Box,
  Alert,
  Typography,
  Paper,
  IconButton,
  CircularProgress,
  Tooltip,
  Chip,
  Grid,
  Button
} from '@mui/material';
import {
  Refresh as RefreshIcon,
  ArrowBack as ArrowBackIcon,
  FilterList as FilterIcon,
  Dashboard as DashboardIcon
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import LogForenseTable from '../../components/Logs/LogForenseTable';
import LogForenseFilter from '../../components/Logs/LogForenseFilter'; // Novo componente
import { getForensicLogs } from '../../services/logService';
import useLogAccess from '../../hooks/useLogAccess';

const LogForensePage = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [showFilters, setShowFilters] = useState(false);
  const [filtros, setFiltros] = useState({
    dataInicio: '',
    dataFim: '',
    acao: '',
    usuarioId: ''
  });
  const navigate = useNavigate();
  const { isAdmin } = useLogAccess();

  const fetchLogs = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await getForensicLogs(filtros);
      console.log('Resposta logs forense:', response.data);
      
      if (response.data && response.data.success) {
        const logsFormatted = response.data.data.logs.map(log => ({
          ...log,
          createdAt: log.created_at || log.createdAt
        }));
        setLogs(logsFormatted);
      } else {
        setLogs([]);
      }
    } catch (error) {
      console.error('Erro ao buscar logs forense:', error);
      setError('Falha ao carregar logs forense. Por favor, tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!isAdmin) {
      navigate('/unauthorized');
      return;
    }
    fetchLogs();
  }, [isAdmin, navigate]);

  const handleFilterChange = (newFiltros) => {
    setFiltros(newFiltros);
  };

  return (
    <Container maxWidth="xl">
      <Box sx={{ py: 3 }}>
        {/* Header com botões */}
        <Box sx={{ mb: 3, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Tooltip title="Voltar para Logs">
              <IconButton onClick={() => navigate('/admin/logs')} size="small">
                <ArrowBackIcon />
              </IconButton>
            </Tooltip>
            <Typography variant="h4" component="h1">
              Logs Forense
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Button
              variant="contained"
              startIcon={<DashboardIcon />}
              onClick={() => navigate('/dashboard')}
            >
              Voltar ao Dashboard
            </Button>
            <Tooltip title="Filtros">
              <IconButton onClick={() => setShowFilters(!showFilters)}>
                <FilterIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Atualizar">
              <IconButton onClick={fetchLogs} disabled={loading}>
                <RefreshIcon />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>

        {/* Filtros */}
        {showFilters && (
          <Grid item xs={12}>
            <Paper sx={{ p: 2, mb: 3 }}>
              <LogForenseFilter 
                filtros={filtros}
                onChange={handleFilterChange}
                onApply={fetchLogs}
              />
            </Paper>
          </Grid>
        )}

        {/* Mensagem de erro */}
        {error && (
          <Alert severity="error" sx={{ mb: 3 }}>
            {error}
          </Alert>
        )}

        {/* Loading state e Tabela */}
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
            <CircularProgress />
          </Box>
        ) : (
          <LogForenseTable logs={logs} />
        )}
      </Box>
    </Container>
  );
};

export default LogForensePage;